import React from "react";
import { useTranslation } from "react-i18next";
import { CalendarIcon } from "lucide-react"; // Use a clean icon

const DatePickerInput = React.forwardRef(({ value, onClick, label }, ref) => {
    const { i18n } = useTranslation();
    const isRTL = i18n.dir() === 'rtl';

    return (
        <div style={styles.container}>
            {label && <label style={styles.label}>{label}</label>}
            <div style={styles.inputWrapper} onClick={onClick} ref={ref}>
                <input
                    type="text"
                    value={value}
                    readOnly
                    style={styles.input}
                    placeholder="Select date & time"
                />
                <CalendarIcon
                    size={18}
                    style={{
                        ...styles.icon,
                        right: isRTL ? 'auto' : '10px',
                        left: isRTL ? '10px' : 'auto'
                    }}
                />
            </div>
        </div>
    );
});

// ✅ Custom Styles
const styles = {
    container: {
        width: "100%",
    },
    label: {
        fontWeight: "bold",
        color: "var(--text)",
        display: "block",
        marginBottom: "5px",
    },
    inputWrapper: {
        display: "flex",
        alignItems: "center",
        position: "relative",
        border: "1px solid var(--border)",
        borderRadius: "var(--radius)",
        padding: "10px 12px",
        width: "100%",
        backgroundColor: "var(--surface)",
        cursor: "pointer",
    },
    input: {
        border: "none",
        outline: "none",
        width: "100%",
        backgroundColor: "transparent",
        fontSize: "14px",
    },
    icon: {
        position: "absolute",
        color: "var(--text-muted)",
        pointerEvents: "none",
    },
};

export default DatePickerInput;
